import React from 'react'

import { useFormattedCurrentDateParts } from '@/components/Event/NewScript/hooks/useFormattedCurrentDateParts'

type Props = {
  timezone: string
}

export const NoShowOffRecordVerbatim: React.FC<Props> = ({ timezone }) => {
  const { formattedTimeWithTimezone } = useFormattedCurrentDateParts(timezone)

  return (
    <>
      Thank you, counsel. The time is {formattedTimeWithTimezone} and we are now
      off the record.
    </>
  )
}
